'use client'

import { useState, useEffect } from 'react'
import { Spin } from 'antd'
import { useLazyQuery } from '@apollo/client'
import {
  RESTORE_PAGE_QUERY,
  RestorePageDataType
} from '@/graphql/queries/page/restore'
import { restore } from '@/workflows/utils'
import { useDispatch } from 'react-redux'

interface IProps {
  children: React.ReactNode
}

export default function RestoreSession({ children }: IProps) {
  const dispatch = useDispatch()
  const [complete, setComplete] = useState<boolean>(false)
  const [getRestoreInfo] = useLazyQuery<RestorePageDataType>(RESTORE_PAGE_QUERY)

  useEffect(() => {
    if (sessionStorage.getItem('restoreSession') === '1') {
      getRestoreInfo().then(({ data }) => {
        if (data?.society?.projectType) {
          restore(dispatch, data)
        }
        setComplete(true)
        sessionStorage.removeItem('restoreSession')
      })
    } else {
      setComplete(true)
    }
  }, [])

  if (!complete) {
    return (
      <div className='absolute top-[50%] left-[50%]'>
        <Spin size='large' />
      </div>
    )
  }

  return children
}
